import BaseApiService from './baseApiService';
import { CalculateStatisticCommand, StatisticsDto } from '../contracts';

class StatisticsApiService extends BaseApiService {
    calculateStatistics = (request: CalculateStatisticCommand) => {
        return this.post<void, CalculateStatisticCommand>('statistic', request);
    };

    loadStatistics = () => {
        return this.get<StatisticsDto>('statistic');
    };

    downloadStatistics = (id: number) => {
        return this.downloadFilePost(`statistic/${id}/download`).then((resp) => resp.data);
    };
}

export default new StatisticsApiService();
